import { render } from "./UXSection.vue?vue&type=template&id=385adb32&scoped=true&class=py-5"
import script from "./UXSection.vue?vue&type=script&lang=js"
export * from "./UXSection.vue?vue&type=script&lang=js"

import "./UXSection.vue?vue&type=style&index=0&id=385adb32&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385adb32"]])

export default __exports__